import { z } from 'zod';
import { documentDtoSchema } from './document.schemas.js';
import { documentValueDtoSchema } from './document.schemas.js';

export const documentPublishedConsultDtoSchema = z.object({
  publishId: z.string().uuid(),
  version: z.number().int(),
  publishName: z.string(),
  publishedAt: z.string().datetime(),
  displayDocument: documentDtoSchema,
  displayValues: z.array(documentValueDtoSchema),
});

export const documentValidationRowDtoSchema = z.object({
  id: z.string().uuid(),
  documentValueId: z.string().uuid(),
  /** 0 = en attente, 1 = validé, 2 = refusé */
  validation: z.number().int(),
  content: z.string().nullable(),
});

export const documentValidationReviewDtoSchema = z.object({
  editLocked: z.boolean(),
  submitId: z.string().uuid().nullable(),
  displayDocument: documentDtoSchema.nullable(),
  displayValues: z.array(documentValueDtoSchema).nullable(),
  /** Dernière publication officielle (souvent même forme que la soumission si générée après validation). */
  baselineSnapshot: z.any().nullable(),
  /** Cliché soumis en attente de validation. */
  submittedSnapshot: z.any().nullable(),
  validations: z.array(documentValidationRowDtoSchema),
  canValidate: z.boolean(),
});

export const documentValidationDecisionSchema = z
  .object({
    decision: z.enum(['approve', 'reject']),
    comment: z.string().max(20_000).optional(),
  })
  .superRefine((data, ctx) => {
    if (data.decision === 'reject' && (!data.comment || data.comment.trim().length === 0)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Un commentaire est obligatoire pour refuser.',
        path: ['comment'],
      });
    }
  });

export type DocumentValidationRowDto = z.infer<typeof documentValidationRowDtoSchema>;
export type DocumentValidationReviewDto = z.infer<typeof documentValidationReviewDtoSchema>;
export type DocumentPublishedConsultDto = z.infer<typeof documentPublishedConsultDtoSchema>;
export type DocumentValidationDecisionInput = z.infer<typeof documentValidationDecisionSchema>;
